import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupNoClan() {
    const navigate = useNavigate();
   
    const [clanName, setClanName] = useState('');

    const handleClanSubmit = async () => {
    if (!clanName.trim()) {
      toast.error("Please enter your clan name.");
      return;
    }

    try {
      const res = await axios.post(
        `${API_URL}/reg-signup-noclan-api`,
        { clan_name: clanName },
        { withCredentials: true }
      );

      if (res.data.Status === "Success") {
        navigate(res.data.redirect);
      } else {
        toast.error("Failed to register clan.");
      }
    } catch (error) {
      console.error("Clan submission error:", error);
      toast.error("Something went wrong.");
    }
  };


    return (
        <div className="bg-med-green min-vh-100 d-flex align-items-center justify-content-center">
            <div className="container">
            <ToastContainer />
            <div className="rowx justify-content-center">
                
            <div className=" clan_border">
                    
        
                        <div className='row'>
                        <p class="h5 text-center">You can register your new clan here.</p>
                        </div>
                        <div className='row' style={{marginTop: '20%'}}>
                        <div className='col-md-2'> </div>
                        <div className='col-md-8'>
                        <label for="account" class="form-label">Enter Your Clan</label>
                        <input
                                type="text"
                                name="clan_name"
                                className="form-control"
                                required
                                value={clanName}
                                onChange={(e) => setClanName(e.target.value)}
                            />
                        </div>
                        <div className='col-md-2'> </div>
                        </div>
                    
                        <div className='row' style={{marginTop: '20%'}}> 

                            <div className='col-4 col-md-4'>
                            <Link onClick={() => navigate(-1)} class="btn btn-primary">
                                &emsp;<i class="fa fa-arrow-left btn_arrow"></i>&emsp;</Link>
                            </div>
                            <div className='col-4 col-md-4'>

                            </div>

                            <div className='col-4 col-md-4'>
                            <button onClick={handleClanSubmit} className="btn btn-primary" type="submit">
                                &emsp;<i className="fa fa-arrow-right btn_arrow"></i>&emsp;</button>
                            </div>
                        </div>
                 
                    

                </div>
            </div>
        </div>
        </div>
    );
}

export default SignupNoClan;
